// src/constants.js

export const API_URL = 'https://humancapitalapi.africanalliance.com';